export const setUserInfo = (Userinfo) => ({
  type: 'SET_USER_INFO',
  payload: Userinfo,
});